// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionReason-cls1__c20050ccac49fe5c01e5","cls2":"SuggestionReason-cls2___0b7061fcb681bd4c791 SuggestionReason-cls1__c20050ccac49fe5c01e5"};